(function() {
  'use strict';

  angular
    .module('traineeWebApp.consts')
    .constant('gac', {
      pages: {
        traineeDashboard: {
          name: "TRAINEE_DASHBOARD",
          actions: {
            getStarted: "trainee_dash_get_started",
            editProfile: "trainee_dash_edit_profile"
          }
        }
      }
    });
})();

